module.exports = __webpack_public_path__ + "img/user-4.148b7579.svg";